import { render, staticRenderFns } from "./ShowUpdateClients.vue?vue&type=template&id=3a2d74da&scoped=true"
import script from "./ShowUpdateClients.vue?vue&type=script&lang=js"
export * from "./ShowUpdateClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2d74da",
  null
  
)

export default component.exports